/* eslint-disable */
import {
  DATA_CHANGED,
  DATA_BATCH_CHANGED,
  DATA_RESET,
} from '../actions/index';

const initialState = {
  user: null,
  announcements: [],
  pupils: [],
  selectedPupil: null,
  selectedPupilIndex: 0,
  defaultDateRange: null,
  defaultDateRangeHomework: null,
  openModal: false,
  messagesSelectedThread: null,
  messagesMultipleMessage: false,
  messagesMultipleMessageSelectedIds: {},
};

const rootReducer = (state = JSON.parse(JSON.stringify(initialState)), action) => {
  let newState;

  switch (action.type) {
    case DATA_CHANGED:
      newState = JSON.parse(JSON.stringify(state));
      newState[action.payload.type] = action.payload.data;
      return newState;
    case DATA_BATCH_CHANGED:
      newState = JSON.parse(JSON.stringify(state));
      for (const key in action.payload) {
        newState[key] = action.payload[key];
      }
      return newState;
    case DATA_RESET:
      return JSON.parse(JSON.stringify(initialState));
    default:
      return state;
  }
};

export default rootReducer;
